import Calendar from 'react-calendar';

const CustomCalendar = (props) => {
  return <Calendar calendarType="US" className="custom-calendar" {...props} />;
};

export default CustomCalendar;
